"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectColor = void 0;
const config_1 = require("../../../config");
function selectColor(measureType) {
    let color;
    if (config_1.config.measurement.colors.options.length < 4) {
        throw new Error("Not enought color options defined in config");
    }
    switch (measureType) {
        case 1 /* DISTANCE */:
            color = config_1.config.measurement.colors.options[0];
            break;
        case 2 /* HEIGHT */:
            color = config_1.config.measurement.colors.options[1];
            break;
        case 3 /* ANGLE */:
            color = config_1.config.measurement.colors.options[2];
            break;
        case 4 /* AREA */:
            color = config_1.config.measurement.colors.options[3];
            break;
        default:
            color = config_1.config.measurement.colors.default;
            break;
    }
    return color;
}
exports.selectColor = selectColor;
